(function () {
  'use strict';

  var STORAGE_KEY = 'selected_city';
  var COOKIE_KEY = 'selected_city';
  var COOKIE_DAYS = 365;
  var CART_ATTRIBUTE_KEY = 'City';
  var SERVER_CITY_SELECTOR = '[data-server-cart-city]';
  var SYNC_GUARD_KEY = 'sc_city_cart_sync_attempt';

  var CITY_CONFIG = {
    jeddah:   { label: 'Jeddah',   variantCity: 'jeddah' },
    makkah:   { label: 'Makkah',   variantCity: 'jeddah' },
    taif:     { label: 'Taif',     variantCity: 'jeddah' },
    medina:   { label: 'Medina',   variantCity: 'jeddah' },

    riyadh:   { label: 'Riyadh',   variantCity: 'riyadh' },
    al_kharj: { label: 'Al Kharj', variantCity: 'riyadh' },

    dammam:   { label: 'Dammam',   variantCity: 'dammam' },
    al_hasa:  { label: 'Al Hasa',  variantCity: 'dammam' },
    jubail:   { label: 'Jubail',   variantCity: 'dammam' }
  };

  var STORE_CONFIG = window.SCStoreConfig || {
    currentStore: 'SA',
    stores: {
      SA: { url: 'https://www.sharbatly.club' },
      BH: { url: 'https://bahrain.sharbatly.club' }
    },
    locations: {
      bahrain: { label: 'Bahrain', variantCity: 'bahrain', store: 'BH' }
    }
  };

  var EXTERNAL_LOCATION_CONFIG = {
    bahrain: (STORE_CONFIG.locations && STORE_CONFIG.locations.bahrain) || {
      label: 'Bahrain',
      variantCity: 'bahrain',
      store: 'BH'
    }
  };

  function normalizeCity(value) {
    if (!value) return '';

    value = String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');

    return CITY_CONFIG[value] ? value : '';
  }

  function normalizeLocation(value) {
    if (!value) return '';

    value = String(value)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');

    return CITY_CONFIG[value] || EXTERNAL_LOCATION_CONFIG[value] ? value : '';
  }

  function isLocalLocation(value) {
    return Boolean(normalizeCity(value));
  }

  function getLocationConfig(value) {
    value = normalizeLocation(value);
    return value ? CITY_CONFIG[value] || EXTERNAL_LOCATION_CONFIG[value] : null;
  }

  function getTargetStore(value) {
    value = normalizeLocation(value);
    if (!value) return '';
    return isLocalLocation(value) ? 'SA' : String(getLocationConfig(value).store || '').toUpperCase();
  }

  function isArabicStorefront() {
    var lang = String(document.documentElement.lang || '').toLowerCase();
    var path = window.location.pathname || '/';
    return lang.indexOf('ar') === 0 || path === '/ar' || path.indexOf('/ar/') === 0;
  }

  function buildStorefrontUrl(value) {
    value = normalizeLocation(value);
    var targetStore = getTargetStore(value);
    var targetConfig = STORE_CONFIG.stores && STORE_CONFIG.stores[targetStore];

    if (!value || isLocalLocation(value) || !targetConfig || !targetConfig.url) return '';

    var targetUrl = new URL(targetConfig.url, window.location.origin);
    targetUrl.pathname = isArabicStorefront() ? '/ar' : '/';
    targetUrl.searchParams.set('sc_city', value);
    targetUrl.searchParams.set('sc_from', 'sa');
    targetUrl.searchParams.set('sc_switched', '1');

    return targetUrl.toString();
  }

  function redirectToLocation(value) {
    var targetUrl = buildStorefrontUrl(value);
    if (!targetUrl) return false;
    window.location.assign(targetUrl);
    return true;
  }

  function acceptIncomingStoreLocation() {
    var params = new URLSearchParams(window.location.search);
    var switched = params.get('sc_switched') === '1';
    var sourceStore = String(params.get('sc_from') || '').toLowerCase();
    var incomingCity = normalizeCity(params.get('sc_city'));

    if (!switched || sourceStore !== 'bh' || !incomingCity) return '';

    persistBrowserCity(incomingCity);
    updateDocumentCity(incomingCity);

    try {
      window.localStorage.setItem('sc_delivery_location_confirmed', '1');
    } catch (error) {}

    params.delete('sc_city');
    params.delete('sc_from');
    params.delete('sc_switched');

    var cleanUrl = window.location.pathname;
    var cleanQuery = params.toString();
    if (cleanQuery) cleanUrl += '?' + cleanQuery;
    cleanUrl += window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);

    return incomingCity;
  }

  function getRouteRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function setCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      expires +
      '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }

    return '';
  }

  function getLocalStorageItem(key) {
    try {
      return window.localStorage
        ? window.localStorage.getItem(key) || ''
        : '';
    } catch (error) {
      return '';
    }
  }

  function setLocalStorageItem(key, value) {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      // The cookie remains available when localStorage is unavailable.
    }
  }

  function getSessionStorageItem(key) {
    try {
      return window.sessionStorage
        ? window.sessionStorage.getItem(key) || ''
        : '';
    } catch (error) {
      return '';
    }
  }

  function setSessionStorageItem(key, value) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      // Session storage is only used as a reload-loop guard.
    }
  }

  function removeSessionStorageItem(key) {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem(key);
      }
    } catch (error) {
      // Session storage is only used as a reload-loop guard.
    }
  }

  function getCity() {
    var city = normalizeCity(getLocalStorageItem(STORAGE_KEY));

    if (city) return city;

    city = normalizeCity(getCookie(COOKIE_KEY));

    if (city) {
      setLocalStorageItem(STORAGE_KEY, city);
      return city;
    }

    return '';
  }

  function getLabel(city) {
    city = normalizeCity(city);
    return city && CITY_CONFIG[city] ? CITY_CONFIG[city].label : '';
  }

  function getVariantCity(city) {
    city = normalizeCity(city);

    return city && CITY_CONFIG[city]
      ? CITY_CONFIG[city].variantCity
      : '';
  }

  function persistBrowserCity(city) {
    setLocalStorageItem(STORAGE_KEY, city);
    setCookie(COOKIE_KEY, city, COOKIE_DAYS);
  }

  function updateDocumentCity(city) {
    document.documentElement.setAttribute('data-selected-city', city);

    document.documentElement.setAttribute(
      'data-selected-variant-city',
      getVariantCity(city)
    );
  }

  function dispatchCityChanged(city, reload) {
    document.dispatchEvent(
      new CustomEvent('city:changed', {
        detail: {
          city: city,
          variantCity: getVariantCity(city),
          reload: reload !== false
        }
      })
    );
  }

  function setCity(city, options) {
    city = normalizeCity(city);

    if (!city) return '';

    persistBrowserCity(city);
    updateDocumentCity(city);
    dispatchCityChanged(city, !(options && options.reload === false));

    return city;
  }

  function syncCartCity(city) {
    city = normalizeCity(city);

    if (!city) {
      return Promise.reject(new Error('Invalid city'));
    }

    var attributes = {};
    attributes[CART_ATTRIBUTE_KEY] = getLabel(city);

    return fetch(getRouteRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Unable to synchronize selected city with the Shopify cart'
        );
      }

      return response.json();
    });
  }

  function readCart() {
    return fetch(getRouteRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function clearCart() {
    return fetch(getRouteRoot() + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to clear cart');
      return response.json();
    });
  }

  function reloadPage() {
    window.location.reload();
  }

  /*
    Use this method from the desktop selector, mobile selector and initial
    city popup. Shopify confirms the cart attribute first; only then do we
    persist the browser city and reload the page.
  */
  function setAndReload(city) {
    city = normalizeCity(city);

    if (!city) {
      return Promise.reject(new Error('Invalid city'));
    }

    return syncCartCity(city).then(function (cart) {
      persistBrowserCity(city);
      updateDocumentCity(city);
      removeSessionStorageItem(SYNC_GUARD_KEY);

      /*
        Existing theme listeners may reload on this event. The explicit
        reload below is a fallback if no listener handles it.
      */
      dispatchCityChanged(city, true);
      window.setTimeout(reloadPage, 0);

      return cart;
    });
  }

  function completeSelection(value) {
    if (isLocalLocation(value)) return setAndReload(value);

    redirectToLocation(value);
    return Promise.resolve({ redirected: true });
  }

  function selectLocation(value, options) {
    options = options || {};
    value = normalizeLocation(value);

    if (!value) return Promise.reject(new Error('Invalid delivery location'));

    var isLocal = isLocalLocation(value);
    var currentCity = getCity();

    if (isLocal && value === currentCity) {
      return Promise.resolve({ changed: false, local: true });
    }

    return readCart()
      .then(function (cart) {
        var hasItems = Boolean(cart && cart.items && cart.items.length);

        if (!hasItems) {
          if (typeof options.showLoader === 'function') options.showLoader();
          return completeSelection(value);
        }

        var confirmation;

        if (!isLocal && typeof options.confirmChange === 'function') {
          confirmation = options.confirmChange(value, getTargetStore(value));
        } else {
          confirmation = window.confirm(
            options.confirmMessage ||
            'Changing your city will clear your cart because product availability depends on location. Do you want to continue?'
          );
        }

        return Promise.resolve(confirmation).then(function (shouldContinue) {
          if (!shouldContinue) {
            if (typeof options.hideLoader === 'function') options.hideLoader();
            return { changed: false, cancelled: true };
          }

          if (typeof options.showLoader === 'function') options.showLoader();

          /*
            Saudi city changes must clear the Saudi cart because variants and
            availability change. A Bahrain switch keeps the Saudi cart intact;
            carts belong to separate Shopify stores and cannot be transferred.
          */
          if (!isLocal) return completeSelection(value);

          return clearCart().then(function () {
            return completeSelection(value);
          });
        });
      })
      .catch(function (error) {
        if (typeof options.hideLoader === 'function') options.hideLoader();
        if (options.errorMessage) window.alert(options.errorMessage);
        throw error;
      });
  }

  function getAllCities() {
    return Object.keys(CITY_CONFIG);
  }

  /*
    The carousel can expose the Liquid-rendered cart city like this:

      data-server-cart-city="{{ cart.attributes['City'] | escape }}"

    If an existing customer already has a browser city but the cart City is
    blank or stale, this synchronizes it once and reloads. No /cart.js request
    is needed during normal page loads.
  */
  function reconcileServerCartCity() {
    var cityNode = document.querySelector(SERVER_CITY_SELECTOR);
    var browserCity = getCity();

    if (!cityNode || !browserCity) {
      return Promise.resolve(false);
    }

    var serverCity = normalizeCity(
      cityNode.getAttribute('data-server-cart-city') || ''
    );

    if (serverCity === browserCity) {
      removeSessionStorageItem(SYNC_GUARD_KEY);

      document.documentElement.classList.remove(
        'sc-city-cart-sync-pending'
      );

      return Promise.resolve(false);
    }

    var syncSignature = browserCity + '|' + serverCity;

    /*
      Prevent an infinite refresh loop if Shopify rejects or delays the value.
    */
    if (getSessionStorageItem(SYNC_GUARD_KEY) === syncSignature) {
      document.documentElement.classList.remove(
        'sc-city-cart-sync-pending'
      );

      return Promise.resolve(false);
    }

    setSessionStorageItem(SYNC_GUARD_KEY, syncSignature);

    document.documentElement.classList.add(
      'sc-city-cart-sync-pending'
    );

    return syncCartCity(browserCity)
      .then(function () {
        reloadPage();
        return true;
      })
      .catch(function (error) {
        removeSessionStorageItem(SYNC_GUARD_KEY);

        document.documentElement.classList.remove(
          'sc-city-cart-sync-pending'
        );

        console.warn('City/cart reconciliation failed:', error);
        return false;
      });
  }

  window.CityState = {
    get: getCity,
    set: setCity,
    setAndReload: setAndReload,
    select: selectLocation,
    syncCart: syncCartCity,
    reconcileCart: reconcileServerCartCity,
    getLabel: getLabel,
    getVariantCity: getVariantCity,
    getLocationConfig: getLocationConfig,
    getTargetStore: getTargetStore,
    isLocal: isLocalLocation,
    buildStorefrontUrl: buildStorefrontUrl,
    redirect: redirectToLocation,
    currentStore: 'SA',
    validCities: getAllCities(),
    config: CITY_CONFIG
  };

  var initialCity = acceptIncomingStoreLocation() || getCity();

  if (initialCity) {
    updateDocumentCity(initialCity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reconcileServerCartCity();
    });
  } else {
    reconcileServerCartCity();
  }
})();
